angular.module('CarsSaraBo').factory('LogoutService', ['$resource', function($resource) {
  return $resource('../logout')}
]);


//////////////////
// WEBPACK FOOTER
// ./public/app/models/logout_service.js
// module id = 854
// module chunks = 3